<template>
    <div class="concept">
      <div class="concept-header">
        <div class="section-line"></div>
        <div class="header-content">
          <div class="title-row">
            <h2 class="concept-title">{{ title }}</h2>
            <div class="concept-label">{{ label }}</div>
          </div>
        </div>
      </div>
      
      <div class="concept-content">
        <p v-for="(paragraph, index) in paragraphs" 
           :key="index" 
           class="concept-paragraph">{{ paragraph }}</p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Concept',
    props: {
      title: {
        type: String,
        required: true
      },
      label: {
        type: String,
        required: true
      },
      paragraphs: {
        type: Array,
        required: true
      }
    }
  }
  </script>
  
  <style>
  .concept {
    position: relative;
    margin: 120px 0;
  }
  
  .concept-header {
    position: relative;
    margin-bottom: 48px;
  }
  
  .section-line {
    position: absolute;
    left: -2000px;
    width: 2000px;
    height: 7px;
    background: #ffffff;
    border-radius: 20px;
    top: 27px;
  }
  
  .header-content {
    margin-left: 4rem;
  }
  
  .title-row {
    display: flex;
    align-items: baseline;
    gap: 24px;
  }
  
  .concept-title {
    font-family: "Asimov", sans-serif;
    font-size: 4.8rem;
    font-weight: 500;
    color: #FFFFFF;
    margin: 0;
    line-height: 1.2;
    letter-spacing: -0.05em;
  }
  
  .concept-label {
    font-family: "Untitled Sans", sans-serif;
    font-size: 2rem;
    font-weight: 500;
    color: #7E7E7E;
  }
  
  .concept-description {
    font-family: "Untitled Serif", serif;
    font-size: 32px;
    line-height: 1.2;
    color: #DFDFDF;
    margin: 16px 0;
    max-width: 800px;
  }
  
  .concept-content {
    margin-left: 4rem;
    width: 800px;
    max-width: 100%;
  }
  
  .concept-paragraph {
    font-family: "Untitled Serif", serif;
    font-size: 24px;
    line-height: 1.5;
    color: #DFDFDF;
    margin-bottom: 24px;
  }
  
  @media (max-width: 768px) {
    .section-line {
      left: -100vw;
      width: 100vw;
    }
    
    .title-row {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }
  }
  </style>